import React from 'react';
import Typography from '../../../base/Typography';
import { DivContainerStyled } from './styles';

export default class RecaptchaInFormBadgeComponent extends React.Component {
  // eslint-disable-next-line class-methods-use-this
  render() {
    return (
      <DivContainerStyled className='safari-inflow-recaptcha-disclaimer'>
        <Typography
          component='small'
          disableBottomPadding>
          This site is protected by reCAPTCHA.
        </Typography>
      </DivContainerStyled>
    );
  }
}
